export const radius = {
  tile: 12,
};
